import { uuidv4 } from "./util";

export function addNotice(content: string, theme: string, icon?: string) {
  const noticeContainer = document.querySelector(".notices");
  if (noticeContainer) {
    const id = uuidv4();
    const notice = document.createElement("div");
    notice.classList.add("notice");
    notice.classList.add(theme);
    notice.dataset.identifier = id;

    if (icon) {
      const i = document.createElement("i");
      i.classList.add("fa-duotone");
      i.classList.add("fa-regular");
      i.classList.add(icon);
      notice.appendChild(i);
    }

    const span = document.createElement("span");
    span.appendChild(document.createTextNode(content));
    notice.appendChild(span);
    noticeContainer.appendChild(notice);

    setTimeout(() => {
      const t = document.querySelector(`[data-identifier="${id}"]`);
      if (t) {
        t.remove();
      }
    }, 5000);
  }
}

export function addInfoNotice(content: string) {
  addNotice(content, "theme-info", "fa-circle-exclamation");
}

export function addErrorNotice(content: string) {
  addNotice(content, "theme-error", "fa-circle-exclamation");
}
